// ────────────────────────────────────────
// RollingNumber — 777 슬롯머신식 세로 롤링 숫자 (효신님 2026-06-13 요청)
// 각 숫자 자리가 0~9 세로 릴(스트립)로 구성되고, 값이 바뀌면 해당 숫자까지
// translateY로 "굴러가서" 멈춘다. 콤마·부호·%·소수점은 고정 문자.
// - GPU transform만 사용 (초당 틱에도 가벼움) · 새 색/토큰 없음 (부모 스타일 상속)
// - key는 오른쪽 기준 거리 — 자릿수가 늘어도(999→1,000) 1의 자리 릴이 유지돼 자연스럽다
// ────────────────────────────────────────
const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export function RollingNumber({ text }: { text: string }) {
  const chars = [...String(text)];
  return (
    <span style={{ display: 'inline-flex', lineHeight: 1, verticalAlign: 'baseline' }} aria-label={text}>
      {chars.map((ch, i) => {
        const key = `c${chars.length - i}`; // 오른쪽부터 거리 (1의 자리 안정)
        if (!DIGITS.includes(ch)) {
          return <span key={key} style={{ display: 'inline-block' }}>{ch}</span>;
        }
        return (
          // clipPath 필수: iOS WebKit은 transform된 자식(합성 레이어)이 overflow:hidden 클립을 뚫고
          // 인접 릴 숫자를 그리는 버그가 있음 (2026-07-10 실기기 총자산 히어로 숫자 겹침) — clip-path는 합성 레이어에도 강제 적용
          <span key={key} style={{ display: 'inline-block', height: '1em', overflow: 'hidden', clipPath: 'inset(0)' }} aria-hidden>
            <span
              style={{
                display: 'block',
                transform: `translateY(-${Number(ch)}em)`,
                // 0.9s + 완만한 가속·감속 — 초단위 틱과 맞물려 끊김 없이 흐르는 느낌 (효신님 "스무스하게·급할 필요 없음")
                transition: 'transform .9s cubic-bezier(.4, 0, .2, 1)',
                transitionDelay: `${Math.min(i * 20, 140)}ms`, // 왼쪽→오른쪽 살짝 시차 = 릴 감성
              }}
            >
              {DIGITS.map((d) => (
                // textAlign center: 릴 폭은 0~9 중 최광 글리프로 고정되는데 명조(Nanum Myeongjo)는 tnum 미지원이라
                // 좁은 '1' 자리가 좌측정렬이면 오른쪽만 벌어져 보임("824,8 17" 자간 벌어짐) → 중앙정렬로 여백 분산
                <span key={d} style={{ display: 'block', height: '1em', lineHeight: '1em', textAlign: 'center' }}>{d}</span>
              ))}
            </span>
          </span>
        );
      })}
    </span>
  );
}
